const SET_IS_INITIAL_LOAD = 'SET_IS_INITIAL_LOAD'
const SET_PORTFOLIO_IS_LOADING = 'SET_PORTFOLIO_IS_LOADING'
const SET_PORTFOLIO_CLASS_ALLOCATIONS_ARE_LOADING = 'SET_PORTFOLIO_CLASS_ALLOCATIONS_ARE_LOADING'
const SET_PORTFOLIO_ACCOUNTS_ARE_LOADING = 'SET_PORTFOLIO_ACCOUNTS_ARE_LOADING'
const SET_PORTFOLIO_HOLDINGS_ARE_LOADING = 'SET_PORTFOLIO_HOLDINGS_ARE_LOADING'
const SET_DOCUMENTS_ARE_LOADING = 'SET_DOCUMENTS_ARE_LOADING'

export default {
  SET_IS_INITIAL_LOAD,
  SET_PORTFOLIO_IS_LOADING,
  SET_PORTFOLIO_CLASS_ALLOCATIONS_ARE_LOADING,
  SET_PORTFOLIO_ACCOUNTS_ARE_LOADING,
  SET_PORTFOLIO_HOLDINGS_ARE_LOADING,
  SET_DOCUMENTS_ARE_LOADING
}



// WEBPACK FOOTER //
// ./src/actionTypes/client/loading.js